import { create } from 'zustand';
import { Host } from '@ui/constants/routes';

export interface HostProps {
  host: Host | null;
  setHost: (host: Host) => void;
}

export const useHostStore = create<HostProps>()((set) => ({
  host: null,
  setHost: (host: Host) => set({ host }),
}));
